import { bookingRecoveryState } from "./bookingRecovery";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { customerPortalPath } from "./constants";
import { CUSTOMER_PORTAL_SESSION_CHANGED, readCustomerPortalSession } from "./session";

export function CustomerPortalGuestGuard({ children }) {
  const location = useLocation();
  const session = readCustomerPortalSession();
  if (session) return <Navigate to={location.state?.from || customerPortalPath("dashboard")} replace state={bookingRecoveryState(location.state, session)} />;
  return children;
}

CustomerPortalGuestGuard.propTypes = { children: PropTypes.node };

export default function CustomerPortalGuard({ children }) {
  const location = useLocation();
  const [session, setSession] = useState(() => readCustomerPortalSession());

  useEffect(() => {
    const sync = () => setSession(readCustomerPortalSession());
    sync();
    window.addEventListener("storage", sync);
    window.addEventListener(CUSTOMER_PORTAL_SESSION_CHANGED, sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener(CUSTOMER_PORTAL_SESSION_CHANGED, sync);
    };
  }, [location.pathname]);

  if (!session) {
    return <Navigate to={customerPortalPath("login")} replace state={{ fromState: location.state, from: `${location.pathname}${location.search}${location.hash}` }} />;
  }
  return children;
}

CustomerPortalGuard.propTypes = { children: PropTypes.node };
